import React, { useEffect } from "react";
import Select from "react-select";
import {
  FloatLabel,
  customStylesForMultiSelect,
} from "../../Utils/CustomComponent";

const UseMultiSelect = ({ title, field, register, setValue, watch, options }) => {

  useEffect(() => {
    register(field);
  }, [field, register]);

  return (
    <div>
      <FloatLabel label={title} value={watch(field)}>
        <Select
          name={field}
          placeholder=""
          isMulti={true}
          options={options}
          value={watch(field)}
          onChange={(selected) => {
            setValue(field, selected);
          }}
          styles={customStylesForMultiSelect}
        />
      </FloatLabel>
    </div>
  );
};

export default UseMultiSelect;
